import { call, put } from 'redux-saga/effects';
import { copy } from 'modules/Taps/services/API/3ndflView';
import { clarifyDeclarationError, clarifyDeclarationSuccess } from '../redux/actions';
import config from 'config';
import { remotePaths } from 'router/routes';

export function* clarifyDeclarationSaga({ payload: { cardId } }) {
  const { isOk, data, error } = yield call(copy, cardId);
  if (isOk) {
    yield put(clarifyDeclarationSuccess(data));
    yield config.goToNewLK(remotePaths.situations);
  } else {
    yield put(clarifyDeclarationError(error));
  }
}
